<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Receipt Orders",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('receipt_orders.plural')) }},
    resourceRoute: {default: 'receipt_orders'},
    modelVariable: {default: 'receipt_order'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('receipt_orders.plural')),
          href: "/receipt_orders",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'ordered_at',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        ordered_at: { type: Date, label: this.lodash.upperFirst(this.$t('receipt_orders.ordered_at')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['receipt_order']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'delivery_order.order_id',
            label: this.lodash.upperFirst(this.$t('receipt_orders.delivery_order')),
            thStyle: { minWidth: '175px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/delivery_orders/${(item.delivery_order || {}).id}`">{{ lodash.get(item.delivery_order, "order_id") }}</router-link>'
            }
          },
          {
            key: 'customer.name',
            label: this.lodash.upperFirst(this.$t('receipt_orders.customer')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/customers/${(item.customer || {}).id}`">{{ lodash.get(item, "customer.name")}}</router-link>'
            }
          },
          {
            key: 'ordered_at',
            label: this.lodash.upperFirst(this.$t('receipt_orders.ordered_at')),
            thStyle: { minWidth: '150px' },
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
            formatter: (value) => {
              return this.$moment.utc(value).local().format('DD MMM, YYYY')
            }
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    getModelName(value) {
      return value['order_id'];
    },
    delete(value) {
      return this.$axios.delete(`/receipt_orders/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/receipt_orders', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          with: 'delivery_order,customer',
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta, aggregate = {} } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('receipt_orders.count')),
            value: this.$numeral(aggregate.count).format('0,0 a'),
            valueTitle: this.$numeral(aggregate.count).format('0,0'),
            icon: 'bx bx-copy-alt'
          },
          {
            title: this.lodash.upperFirst(this.$t('receipt_orders.count_customer_id')),
            value: this.$numeral(aggregate.count_customer_id).format('0,0 a'),
            valueTitle: this.$numeral(aggregate.count_customer_id).format('0,0'),
            icon: 'bx bx-user'
          }
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
